import React from "react";

function FilterIcon() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="22"
      height="22"
      enableBackground="new 0 0 512 512"
      viewBox="0 0 28 28"
    >
      <switch>
        <g>
          <path
            fill="#fff"
            d="M12 26c-.55 0-1-.45-1-1V13.24c0-.53-.21-1.04-.59-1.41L2.29 3.71a.996.996 0 010-1.41A1 1 0 013 2h22a1.003 1.003 0 01.71 1.71l-8.12 8.12c-.38.37-.59.88-.59 1.41V21c0 .27-.11.52-.29.71l-4 4c-.19.18-.44.29-.71.29zM5.41 4l6.41 6.41c.75.75 1.17 1.77 1.17 2.83v9.34l2-2v-7.34c0-1.06.42-2.08 1.17-2.83L22.59 4z"
            data-original="#000000"
          ></path>
        </g>
      </switch>
    </svg>
  );
}

export default FilterIcon;